import { Component } from '@angular/core';

@Component({
  selector: 'app-payment-panel-paygreen-trd',
  templateUrl: './payment-panel-paygreen-trd.component.html',
})
export class PaymentPanelPaygreenTrdComponent {}
